import { ProductPagePaths } from "@faire/retailer-visitor-shared/paths/ProductPage";
import qs from "qs";

export const getProductUrlWithSwatchOption = (
  productToken: string,
  existingProductUrl: string,
  selectedSwatchOptionToken?: string
): string => {
  if (selectedSwatchOptionToken) {
    const queryString = existingProductUrl.includes("?")
      ? existingProductUrl.split("?")[1]
      : "";
    const parsedParams = qs.parse(queryString ?? "");
    parsedParams.productOptionToken = selectedSwatchOptionToken;
    return ProductPagePaths.index(
      productToken,
      parsedParams as ProductPagePaths.index.IQueries
    );
  }
  return existingProductUrl;
};
